import React, { MouseEventHandler } from "react"

import { WOWNET_CONTENT } from "@shared/constants"
import { useSchedule } from "@shared/contexts"

import { WownetContentType } from "live/constants"

import Button from "./Button"

const JoinInfo = () => {
  const { schedule } = useSchedule()
  const streamerUsername = schedule?.user.username

  const handleLinkJoinInfo: MouseEventHandler = (e) => {
    e.preventDefault()

    window.open(
      `${WOWNET_CONTENT.link}/?type=${WownetContentType.INFO}&analid=${streamerUsername}`,
    )
  }

  return (
    <Button
      label="가입안내"
      className="quickJoinInfo"
      onClick={handleLinkJoinInfo}
    />
  )
}

export default JoinInfo
